"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusModalTextConfigs = void 0;
const types_1 = require("../model/types");
// StatusModal
exports.statusModalTextConfigs = {
    [types_1.StatusModalTypes.SUCCESS]: {
        icon: 'check',
        iconColor: 'green',
        modalMessage: '成功'
    },
    [types_1.StatusModalTypes.FAIL]: {
        icon: 'failed',
        iconColor: 'red',
        modalMessage: '失敗'
    },
    [types_1.StatusModalTypes.WARNING]: {
        icon: 'warning',
        iconColor: 'orange',
        modalMessage: ''
    }
};
